export default "__VITE_ASSET__DNQhYZHK__"